import { UPDATE_MOVIE,UPDATE_FILMS, UPDATE_VIDEO_STATUS } from '../constants'
import store from '../store'

export const updateMovie = movie => store.dispatch({ type: UPDATE_MOVIE, movie }) 
export const updateFilms = movie => store.dispatch({ type: UPDATE_FILMS,movie })
export const updateVideoStatus = (videoId, status) => store.dispatch({type: UPDATE_VIDEO_STATUS, videoId, status});